import React from 'react';

export const UserDataContext = React.createContext(/** @type {UserDataContextValue | undefined} */ (undefined));
